import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useUser } from "@dreamchimney/user-context";
import PageMiddle from "./PageMiddle";

const RouteWithMiddle = ({ component: Component, chimOnly = false, withNav = true, keyId = null, name, ...rest }) => {
  const { state: userState } = useUser();
  if (chimOnly) {
    if (!userState.loaded) {
      return null;
    }
    if (!userState.loggedin || !userState.isChim) {
      return (
        <Redirect
          to={{
            pathname: "/",
          }}
        />
      );
    }
  }
  return (
    <Route
      name={name}
      {...rest}
      render={(props) => {
        const useKey = keyId ? `${name}-${props.match.params[keyId]}` : null;
        return (
          <PageMiddle withNav={withNav}>
            <Component key={useKey} {...props} />
          </PageMiddle>
        );
      }}
    />
  );
};
export default RouteWithMiddle;
// render={(props) => <DetailPage key={`sleeve-${props.match.params.id}`} {...props} />}
